import React from "react";
import PropTypes from "prop-types";
import { Button } from "components/common/button";
import { documentPropType } from "custom-prop-types";

export const ProcessingToggle = ({
  isBeingCancelled,
  isCancelProcessingLoading,
  onCancelProcessingAllDocuments,
  onProcessAllDocuments,
  pendingDocuments
}) => {
  if (isBeingCancelled) {
    return (
      <span className="manual7">
        <Button
          loading={ isCancelProcessingLoading }
          onClick={ () => onProcessAllDocuments(pendingDocuments) }
          primary
        >
         Process Documents Automatically
        </Button>
      </span>
    );
  }
  return (
    <span className="manual7">
      <Button
        danger
        loading={ isCancelProcessingLoading }
        onClick={ () => onCancelProcessingAllDocuments(pendingDocuments) }
      >
        Cancel Processing Documents
      </Button>
    </span>
  );
};

ProcessingToggle.propTypes = {
  isBeingCancelled: PropTypes.bool.isRequired,
  isCancelProcessingLoading: PropTypes.bool.isRequired,
  onCancelProcessingAllDocuments: PropTypes.func.isRequired,
  onProcessAllDocuments: PropTypes.func.isRequired,
  pendingDocuments: PropTypes.arrayOf(documentPropType).isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/upload-documents/processing-toggle.jsx